import {slideDown, slideUp} from "../Utility/utils";

const body = document.querySelector('body');

export const InitializeContactForms = () => {
  const formEls = document.querySelectorAll('.contact-form__form');

  if( formEls ) {
    formEls.forEach(formEl => {
      td_set_form(formEl);
    });
  }

  // Form Toggling
  const formToggles = document.querySelectorAll('.contact-form__toggles button');
  if(formToggles.length){
    formToggles.forEach(toggle => {
      if(!toggle.initialized){
        toggle.initialized = true;
        const formWrapper = toggle.closest('.contact-form');

        toggle.addEventListener('click', function(){
          toggle.blur();

          if(toggle.classList.contains('active')) return;

          // Reset previously active form/toggle
          const prevActiveToggle = formWrapper.querySelector('.contact-form__toggles button.active');
          const prevActiveForm = formWrapper.querySelector('.contact-form__form_wrap.active');
          if(prevActiveToggle && prevActiveForm){
            prevActiveToggle.classList.remove('active');
            prevActiveToggle.setAttribute('aria-hidden','true');
            prevActiveForm.classList.remove('active');
            prevActiveForm.setAttribute('aria-hidden', 'true');
          }

          // Set new active form/toggle
          const targetID = toggle.getAttribute('aria-controls');
          const target = formWrapper.querySelector('#' + targetID);
          toggle.classList.add('active');
          target.setAttribute('aria-hidden', 'false');
          target.classList.add('active');

          // Set URL Form Param
          const url = window.location;
          const newURL = new URL(window.location.origin + window.location.pathname);
          newURL.searchParams.set('form', toggle.getAttribute('data-form'));
          history.replaceState({}, '', newURL);
        });
      }
    });
  }
}

export const td_set_form = (formEl) => {
  // Form Submission
  if(!formEl.initialized){
    formEl.initialized = true;
    formEl.addEventListener('submit', (e) => {
      e.preventDefault();
      submitContactFormData(formEl);
    });
  }

  // Form input classes for label positioning
  const inputs = formEl.querySelectorAll('input[type="text"], input[type="email"], input[type="number"], textarea');
  if(!!inputs){
    inputs.forEach(input => {
      if(!input.initialized){
        input.initialized = true;

        input.addEventListener('focus', () => {
          input.classList.add('focus');
          setInputActiveState(input);
          setPlaceholderState(input);
        });
        input.addEventListener('change', () => {
          setInputActiveState(input);
          setPlaceholderState(input);
        });
        input.addEventListener('focusout', () => {
          input.classList.remove('focus');
          setInputActiveState(input);
          setPlaceholderState(input);
        });
      }
    });
  }

  // File Upload Size Validation
  const fileUploadInputs = formEl.querySelectorAll('input[type="file"]');
  if(!!fileUploadInputs){
    fileUploadInputs.forEach(input => {
      if(!input.initialized){
        input.initialized = true;
        const maxSize = input.getAttribute('data-max-file-size');
        input.addEventListener('change', () => {
          gformValidateFileSize( input, maxSize );
        });
      }
    });
  }
}

const submitContactFormData = async (formEl) => {
  const formData = new FormData( formEl );
  const formID = formData.get('form_id');
  const formTitle = formEl.getAttribute('data-form-title');
  const endpoint = `/wp-json/gf/v2/forms/${formID}/submissions`;
  const block = formEl.closest('.contact-form__form_wrap');

  // Add classes while submitting, which will be removed when a response is received
  block.classList.add('submitting');
  body.classList.add('form-submitting');

  // Fetch data from Gravity Forms API
  const response = fetch( endpoint, {
    method: "POST",
    body: formData
  });

  response
    .then(res => res.json())
    .then(d => {

      // Remove submitting classes
      block.classList.remove('submitting');
      body.classList.remove('form-submitting');

      // Clear any error headings that may be present
      if(!!block.querySelector('.gform_validation_errors')){
        block.querySelector('.gform_validation_errors').remove();
      }

      // if the submission was valid, hide the form and display the confirmation message
      if(d.is_valid){
        formEl.style.display="none";
        const confirmationDiv = block.querySelector('.gform_confirmation');
        confirmationDiv.innerHTML = '<h2 class="h3">' + d.confirmation_message + '</h2>';

        // Additionally, if the footer newsletter, add a class to the wrapper div.
        if(formEl.closest('.footer-newsletter')){
          formEl.closest('.footer-newsletter').classList.add('form-submitted');
        }

        // If it's a newsletter signup block, add the submitted class to the block wrapper
        if(formEl.closest('.news_signup')){
          formEl.closest('.news_signup').classList.add('form-submitted');
        }

        // Add google tracking event
        // gtag('event', 'formSubmitted', {
        //   'formName' : formTitle
        // });
      }
      else {
        // Reset any error classes that may have been present to start fresh
        const errorFields = block.querySelectorAll('.has_error');
        let parent;
        errorFields.forEach(field => {
          parent = !!field.closest('.has_sub_fields') ? field.closest('.has_sub_fields') : field.parentNode;
          parent.classList.remove('has_error');
          parent.querySelector('.field_error_notification').remove();
        });

        // Add error classes/messages to fields that are invalid
        if(d.validation_messages){
          for (const key in d.validation_messages) {
            const field = block.querySelector('[data-field-id="' + key + '"]');
            parent = !!field.closest('.has_sub_fields') ? field.closest('.has_sub_fields') : field.parentNode;

            parent.classList.add('has_error');

            // For URL validation error messages, replace 'gravityforms.com' with 'yourwebsite.com'
            const validationMessage = d.validation_messages[key].replace('gravityforms.com', 'yourwebsite.com');

            const errorDiv = document.createElement('div');
            errorDiv.classList.add('contact-form__field_notification');
            errorDiv.classList.add('field_error_notification');
            errorDiv.innerHTML = '<span>' + validationMessage + '</span>';
            parent.appendChild(errorDiv);
          }
        }

        // Add an error message above the form
        const errorHeading = document.createElement('div');
        errorHeading.classList.add('gform_validation_errors');
        errorHeading.innerHTML = '<h2 class="contact-form__header_notification gform_submission_error hide_summary">There was a problem with your submission. Please review the fields below.</h2>';
        block.prepend(errorHeading);
      }
    });
};

const setInputActiveState = (input) => {
  const wrapper = input.closest('.field_wrap');
  const isFocused = input.classList.contains('focus');

  if(isFocused || input.value){
    wrapper.classList.add('input_initiated');
  }
  else {
    wrapper.classList.remove('input_initiated');
  }
}

const setPlaceholderState = (input) => {
  const placeholder = input.getAttribute('data-placeholder');
  const isFocused = input.classList.contains('focus');

  if(isFocused && !input.value){
    input.setAttribute('placeholder', placeholder);
  }
  else {
    input.setAttribute('placeholder', '');
  }
}

// Form File Upload Validation
// Taken from Gravity forms and refactored to vanilla JS
const gformValidateFileSize = ( field, max_file_size ) => {
  // Get validation message element.
  const validation_element = field.closest( 'div' ).querySelector( '.validation_message' );
  validation_element.style.display = '';

	// If file API is not supported within browser, return.
	if ( ! window.FileReader || ! window.File || ! window.FileList || ! window.Blob ) {
		return;
	}

	// Get selected file.
	var file = field.files[0];

	// If selected file is larger than maximum file size, set validation message and unset file selection.
	if ( file && file.size > max_file_size ) {

		// Set validation message.
		validation_element.innerHTML = file.name + " - This file exceeds the file size limit";
    validation_element.style.display = 'block';
  }

}


export const InitAOSForms = () => {

  let i = 0;
  let interval = setInterval(() => {
    i++;

    const forms = document.querySelectorAll('.ao-form');
    
    if(i > 20 || forms.length){
      clearInterval(interval);
    }

    if(forms.length){
      forms.forEach(form => {
        if(form.initialized){
          return;
        }

        form.initialized = true;

        // Remove inline styles from submit buttons
        remove_aos_form_button_styling(form);

        // watch select fields to add .selected class when user picks an option
        const selects = form.querySelectorAll('select');
        if(selects.length){
          selects.forEach(select => {
            select.addEventListener('change', function () {
              if (select.value === '') {
                select.classList.remove('selected');
              } else {
                select.classList.add('selected');
              }
            });
          });
        }

        // Watch for form submissions to remove button styles on download links
        form.addEventListener('submit', () => {
          let i = 0;
          let submissionCheckInterval = setInterval(() => {
            i++;
            const errorFields = form.querySelectorAll('.ao-form-error');

            if(i > 30 || errorFields.length || !document.contains(form)){
              clearInterval(submissionCheckInterval);
            }

            if(!document.contains(form)){
              InitAOSForms();
            }
          }, 100);
        });
      });
    }
  }, 300);
}


const remove_aos_form_button_styling = (form) => {
  const buttons = form.querySelectorAll('button, .aoButtonAnchor');
  if(buttons.length){
    buttons.forEach(button => {
      button.setAttribute('style', '');
      button.setAttribute('onmouseout', '');
      button.setAttribute('onmouseover', '');
      button.classList.add('btn');
    });
  }
}
